import type { FunctionComponent } from 'react'
import React from 'react'
import { MultiLinkCard, TypographyV2 as Typography } from '@which/seatbelt'

import classnames from 'classnames'

import type { SubVerticalReviewsPageQuery } from '../../../../generated/frontend'
import { groupLinksByType } from '../../../../shared/utils/group-links-by-type'
import styles from './SuperCategorySection.module.scss'

export const SuperCategorySection: FunctionComponent<Props> = ({ superCategorySections = [] }) => {
  if (!superCategorySections?.length) {
    return null
  }

  return (
    <div className={styles.wrapper} data-testid="super-category-wrapper">
      {superCategorySections.map(({ collectionName, cards, sectionId }) => (
        <section key={sectionId} id={sectionId}>
          <Typography
            tag="h2"
            textStyle="sb-text-body-default-strong"
            className={styles.categoryHeading}
            data-testid="super-category-heading"
          >
            {collectionName}
          </Typography>
          <div className={styles.categoryGrid}>
            {cards.map(({ heading, image, items, link: viewAllLink, titleLink }, index) => {
              const itemLinksData = items.map(({ text, href, linkType }) => ({
                text,
                href,
                type: linkTypesMapper[linkType],
              }))

              const links = groupLinksByType(itemLinksData) || []

              // TEMPORARY - remove categoryGridItemLowRes once all collection images have been replaced
              // with 2:1 high res images in glide [Ticket placeholder here: CTX-198]
              return (
                <div
                  className={classnames(
                    styles.categoryGridItem,
                    !image?.sources.length && styles.categoryGridItemLowRes
                  )}
                  key={`card-${index}`}
                >
                  <MultiLinkCard
                    title={heading}
                    titleLink={titleLink ? titleLink : viewAllLink?.href}
                    image={image?.src}
                    imageSources={image?.sources}
                    imageAlt={image?.alt}
                    links={links}
                    viewAllLink={viewAllLink}
                    className={styles.categoryCard}
                  />
                </div>
              )
            })}
          </div>
        </section>
      ))}
    </div>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  superCategorySections: SubVerticalReviewsPageQuery['subVerticalPage']['reviewsCategories']['sections']
}

const linkTypesMapper = {
  'Best Buy': 'bestBuy',
  "Don't Buy": 'dontBuy',
  'Product Listing': 'standard',
}
